export { OnboardingSplitScreenStep } from "./OnboardingSplitScreenStep";
export type { PillConfiguration } from "./OnboardingSplitScreenStep.d";
